module.exports = require("babel-runtime/helpers/typeof");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/typeof"
// module id = 23
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 14